/**
 * This package's translations, registered at import.
 *
 * French and English only — see `feature-referential/src/i18n.ts` for why.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "clients";

registerNamespace(NAMESPACE, { en, fr });
